// Informacion tecnica de solo lectura que acompana a cada solicitud.

// Las pantallas de detalle marcan la pestaña activa con `laboral-exp-tab-btn-active`
// (y sub-pestañas de audiencias con `audiencia-subtab-btn-active`); los modales
// con antd Tabs usan `ant-tabs-tab-active`. De cada selector se toma el ultimo
// coincidente (los modales se montan al final del DOM) y se unen con " › ".
const SELECTORES_TAB_ACTIVA = [".laboral-exp-tab-btn-active", ".audiencia-subtab-btn-active", ".ant-tabs-tab-active"];

export function leerPestanaActiva() {
  const partes = [];
  for (const sel of SELECTORES_TAB_ACTIVA) {
    const els = document.querySelectorAll(sel);
    const el = els[els.length - 1];
    const limpio = (el?.textContent || "").replace(/\s+/g, " ").trim();
    if (limpio) partes.push(limpio);
  }
  return partes.join(" › ");
}

// Version de la app: REACT_APP_VERSION en el build, o la que exponga Electron.
// CRA no permite importar package.json desde src.
const versionApp = () =>
  process.env.REACT_APP_VERSION || window.electronAPI?.version || "No disponible";

const pad = (n) => String(n).padStart(2, "0");
const fechaHoraLocal = (d = new Date()) =>
  `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`;

// `tituloVista` es el mismo texto que muestra la barra superior (ElectronHeader).
export function recolectarInfoTecnica(pathname, tituloVista) {
  return {
    ruta: pathname,
    tituloVista: tituloVista || "",
    pestanaActiva: leerPestanaActiva(),
    usuario: localStorage.getItem("email") || "",
    rol: localStorage.getItem("role") || "",
    fechaHora: fechaHoraLocal(),
    resolucionCorta: `${window.innerWidth}x${window.innerHeight}`,
    resolucion: `${window.innerWidth}x${window.innerHeight} (pantalla ${window.screen.width}x${window.screen.height}, escala ${window.devicePixelRatio || 1})`,
    versionApp: versionApp(),
  };
}

export const construirMigas = (info) => [info.tituloVista, info.pestanaActiva].filter(Boolean);
